<template>
  <div class="page-content">
    <div class="page-header">
      <div class="searchbar fl">
        <el-form
          :inline="true"
          :model="filters"
          :size="btnSize"
          @keyup.enter.native="handleQuery()"
          @submit.native.prevent
        >
          <el-form-item label="时间类型">
            <el-select
              v-model="filters.dateTimeType"
              size="small"
              style="width:150px"
              placeholder="请选择时间类型"
            >
              <el-option :value="1" :label="'合同签订时间'"></el-option>
              <el-option :value="2" :label="'合同时间'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker
              style="width: 130px;"
              v-model="filters.startTime"
              type="date"
              placeholder=""
            >
            </el-date-picker>
            -
            <el-date-picker
              style="width: 130px;"
              v-model="filters.endTime"
              type="date"
              placeholder=""
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button :size="btnSize" @click="handleQuery" type="primary"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button :size="btnSize" @click="handleAddOrUpdate" type="primary"
              >添加合同</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <el-table
        ref="table"
        class="simple-table"
        :data="tableData"
        height="100%"
        highlight-current-row
        fit
        v-loading="dataListLoading"
      >
        <el-table-column
          prop="id"
          label="合同ID"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="signingTime"
          label="签订时间"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="startTime"
          label="托管开始时间"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="endTime"
          label="托管结束时间"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="propertyCompanyName"
          label="物业公司"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="status"
          label="合同状态"
          align="left"
          min-width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ contractState[scope.row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          align="left"
          min-width="100"
        >
          <template slot-scope="scope">
            <el-button
              class="table-btn"
              @click.native.prevent="handleDetail(scope.$index, scope.row)"
              type="text"
              :size="sizeMini"
              >查看详情</el-button
            >
            <el-button
              class="table-btn"
              v-if="scope.row.status === 1"
              @click.native.prevent="handleTermination(scope.$index, scope.row)"
              type="text"
              :size="sizeMini"
              >终止</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-or-update
      ref="addOrUpdate"
      v-if="addOrUpdateVisible"
      @handleQuery="handleQuery"
    ></add-or-update>
    <detail-dialog
      ref="detailDialog"
      v-if="detailDialogVisible"
    ></detail-dialog>
  </div>
</template>

<script>
import addOrUpdate from "./addOrUpdate.vue";
import detailDialog from "./detailDialog.vue";
import dateTool from "@/utils/dateTool.js";
import config from "@common/config/index.js";
import api from "@common/api/index.js";
export default {
  name: "property",
  components: {
    addOrUpdate,
    detailDialog,
  },
  data() {
    return {
      contractState: config.contractState,
      filters: {
        dateTimeType: 1,
        startTime: null,
        endTime: null,
      },
      type: 0,
      addOrUpdateVisible: false,
      dataListLoading: false,
      detailDialogVisible: false,
      pageNum: [10, 20, 30],
      pageSizes: 1,
      pageSize: 1,
      totalSize: 1,
      btnSize: "small",
      sizeMini: "mini",
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleQuery() {
      // switch (this.filters.type) {
      //   // 租赁
      //   case 0:
      //     this.type = this.filters.type
      //     this.$api.rentalArea.getLeaseContractForProperty().then((res) => {
      //       if (res.success) {
      //         this.handleTableData(res.data)
      //       }
      //     })
      //     break
      //   // 托管
      //   case 1:
      //     this.type = this.filters.type
      //     this.$api.rentalArea.getRentalAreaTrusteeshipContractForProprietor().then((res) => {
      //       if (res.success) {
      //         this.handleTableData(res.data)
      //       }
      //     })
      //     break
      // }
      let { dateTimeType, startTime, endTime } = this.filters;
      let signingTimeLeft = null;
      let signingTimeRight = null;
      if (dateTimeType === 1) {
        signingTimeLeft = this.cheackNull(startTime);
        signingTimeRight = this.cheackNull(endTime);
        startTime = null;
        endTime = null;
      } else {
        startTime = this.cheackNull(startTime);
        endTime = this.cheackNull(endTime);
      }
      this.$api.rentalArea
        .getRentalAreaTrusteeshipContractForProprietor(
          0,
          null,
          signingTimeLeft,
          signingTimeRight,
          startTime,
          endTime,
          -1
        )
        .then((res) => {
          if (res.success) {
            this.handleTableData(res.data);
          }
        });
    },
    cheackNull(time) {
      if (time) {
        return dateTool.format(time, "yyyy/MM/dd hh:mm:ss");
      }
      return null;
    },
    handleTableData(data) {
      // )
      this.tableData = data;
    },
    handleAddOrUpdate() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    handleDetail(index, row) {
      this.detailDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.detailDialog.init(row);
      });
    },
    handleTermination(index, row) {
      this.$confirm("确认要终止吗？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        cancelButtonClass: "btn-custom-cancel",
        type: "warning",
      }).then(() => {
        api.rentalArea
          .terminateRentalAreaTrusteeshipContract(row.id)
          .then((res) => {
            if (res.success) {
              this.$message("终止成功");
              row.status = 3;
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  margin: 16px;
  padding: 16px;
  width: calc(100% - 32px);
  height: calc(100% - 32px);
  background-color: #fff;
  box-sizing: border-box;
  overflow: auto;
  .page-header {
    width: 100%;
    text-align: left;
    color: #333;
  }
  .content {
    height: 700px;
  }
  .pagination-content {
    text-align: right;
  }
}
</style>
